import { render, staticRenderFns } from "./OtherPageDetail.vue?vue&type=template&id=6c358723&scoped=true&"
import script from "./OtherPageDetail.vue?vue&type=script&lang=js&"
export * from "./OtherPageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c358723",
  null
  
)

export default component.exports